import { render, staticRenderFns } from "./review_link.vue?vue&type=template&id=34b4a0a5&scoped=true&"
import script from "./review_link.vue?vue&type=script&lang=js&"
export * from "./review_link.vue?vue&type=script&lang=js&"
import style0 from "./review_link.vue?vue&type=style&index=0&id=34b4a0a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4a0a5",
  null
  
)

export default component.exports